import { css } from "styled-components"
import { colors } from "../../helpers/colors"

export const BannerWrapperStyles = css`
  border: 1px solid ${colors.blue};
`
export const HeadingWrapperStyles = css`
  & > h4 {
    font-style: italic;
  }
`
export const ButtonsWrapperStyles = css``
